import React, { useState } from 'react';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import NavigationBar from '../../ReusableComp/NavigationBar';
import Loader from '../../ReusableComp/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import {  Container, Stack, Table,Row,Col } from "react-bootstrap";
// import { getPmsChangerLoggerData,getPmsAuditLoggerData } from '../../../Redux/actions/actions';
import { useEffect } from 'react';
import { base_url } from '../../../utilities';
import FileSaver from 'file-saver';
import * as XLSX from "xlsx";
import Paginate from '../../ReusableComp/Paginate';
import Pagination from '../PMS_Study_Details/Pagination';

const PMSAdminChangeLogger2 = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    let rolecode = localStorage.getItem('role_code');
    const pmsAuditLoggerrData=useSelector((state)=>state.pmsAuditLoggerData)
    const [searchText, setSearchText] = useState("");
  
    const [changeLoggerData,setChangeLoggerData]=useState([]);
    const [currentPage, setCurrentPage] = useState(
        location.state == undefined || location.state == null
          ? 1
          : location.state.data
      );

    const [loading_flag,Setloading_flag]=useState(false);
    const [asc,setAsC]=useState(false);
    const [desc,setDesc]=useState(false);
    const [pmsChangeData,setPmsChangeData]=useState([]);
    const [currentPagePagination, setCurrentPagePagination] = useState(1);
  

    useEffect(()=>{
        Setloading_flag(true);
    },[])




    useEffect(()=>{
     getCall();
    
    },[])

    const getCall=()=>{
       // Get today's date
       var today = new Date();

       // Get last week's date
       var lastWeek = new Date(today);
       lastWeek.setDate(today.getDate() - 1);
       
 
       // Format the dates in the desired format (assuming YYYY-MM-DD)
       var todayFormatted = today.toISOString().split('T')[0];
       var lastWeekFormatted = lastWeek.toISOString().split('T')[0];
       setStartRange(lastWeekFormatted);
       setEndRange(todayFormatted);
       axios
       .post(base_url + "changeLoggerv2/fetch_details_in_date_range",{
           "from_date":lastWeekFormatted,
           "to_date":todayFormatted
       })
       .then((res) => {
           setPmsChangeData(res.data.data);
          //  setChangeLoggerData(res.data.data)
           setTimeout(()=>{
             Setloading_flag(false);
           },200);
       })
       .catch((err) => {
         console.log(err);
       });
    }

    useEffect(() => {
      if (currentPage === 2) {
        window.scrollTo(0, 0);
      }
    }, [currentPage]);


    
  useEffect(()=>{
    if(searchText===""){
      setChangeLoggerData([]);
    }
  },[searchText])

   const getDate=(date)=>{
    const utcDate = new Date(date);
    // Convert to India Standard Time (IST)
    utcDate.setHours(utcDate.getHours() + 5); // Add 5 hours to UTC time
    utcDate.setMinutes(utcDate.getMinutes() + 30); // Add 30 minutes to UTC time
    // Format the IST date and time
    const istDate = utcDate.toISOString().slice(0, 10); // Extract the date part (YYYY-MM-DD)
    const istTime = utcDate.toISOString().slice(11, 16); // Extract the time part (HH:MM:SS)
    // Split the date string into an array of its components
    const dateArray = istDate.split('-');

    // Reverse the array
    const reversedDateArray = dateArray.reverse();

  // Join the reversed array back into a string
    const reversedDate = reversedDateArray.join('-');
    
    return `${reversedDate + " " + istTime}`;
   }


 

   const handleSearchData = (event) => {
    const searchText = event?.target?.value?.toLowerCase();
    setSearchText(searchText);
  
    if (searchText.length > 0) {
      const filterData = changeLoggerData?.length > 0 ? changeLoggerData : pmsChangeData;
  
      const filteredData = filterData?.filter((item) => {
        const actionType = item?.actors?.toLowerCase() || "";
        const createdType = item?.UserAccess?.name?.toLowerCase() || "";
  
        return actionType?.includes(searchText) || createdType?.includes(searchText);
      });
  
      setChangeLoggerData(filteredData);
      setCurrentPagePagination(1);
    } else {
      setChangeLoggerData([]);
    }
  };
  


  useEffect(()=>{
    if(searchText===""){
      setChangeLoggerData([]);
    }
  },[searchText])

  function exportToExcel() {

    let data_excel=changeLoggerData.length>0 ? changeLoggerData:pmsChangeData;

    let excelArray = [];
    data_excel?.forEach((i,index) => {
      
      let xl_object = {
        "S.No":index+1,
        "Persona":i?.actors,
        "Entity":i?.entity,
      "Action": i?.action,
      "change_from": JSON.stringify(i?.change_from, (key, value) => {
        if (typeof value === 'object' && !Array.isArray(value)) {
      
          const keysAndValues = Object.keys(value).map(k => {
            if (k === 'aadhar_card_number') {
              return `${k} : ******** ${value[k].slice(-4)}`;
            }
            return `${k}: ${value[k]}`;
          });
      
          return keysAndValues.join(', ');
        }
        return value;
      }),
      
      "change_to": JSON.stringify(i?.change_to, (key, value) => {
        if (typeof value === 'object' && !Array.isArray(value)) {
      
          const keysAndValues = Object.keys(value).map(k => {
            if (k === 'aadhar_card_number') {
              return `${k} : ******** ${value[k].slice(-4)}`;
            }
            return `${k}: ${value[k]}`;
          });
      
          return keysAndValues.join(', ');
        }
        return value;
      }),
      "Created By":i?.UserAccess?.name,
      "Created": getDate(i?.createdAt),
        "Updated": getDate(i?.updatedAt),
      };

    xl_object["change_from"] = xl_object["change_from"].substring(1, xl_object["change_from"].length - 1);
    xl_object["change_to"] = xl_object["change_to"].substring(1, xl_object["change_to"].length - 1);

      excelArray.push(xl_object);
    });

    const data = excelArray;

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = `Audit Logger.xlsx`;
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);         
}




const [currentPage1, setCurrentPage1] = useState(1);
const [postsPerPage,setPostsPerPage] = useState(10);
const indexOfLastPost = currentPage1 * postsPerPage;
const indexOfFirstPost = indexOfLastPost - postsPerPage;
const [bool,setBoolean]=useState(false);
const [searchBool,setSearchBool]=useState(false);

const paginate = (pageNumber) => {
   
   setCurrentPage1(pageNumber);
};

const previousPage = () => {
 if (currentPage1 !== 1) {
    setCurrentPage1(currentPage1 - 1);
    
 }
};

const nextPage = () => {
 if (currentPage1 !== Math.ceil(pmsChangeData?.length / postsPerPage)) {
    setCurrentPage1(currentPage1 + 1);
 }
};

const[startRange,setStartRange]=useState();
const[endRange,setEndRange]=useState();

const today = new Date().toISOString().split('T')[0];
const [date_today,setDateToday]=useState(today);

const handleStartRange = (e) => {
  if(e.target.value===""){
    setEndRange("")
  }
    if (endRange) {
      // Parse the selected start and end dates as Date objects
      const startDate = new Date(e.target.value);
      const endDate = new Date(endRange);
  
      // Compare the start and end dates
      if (startDate > endDate) {
        setDateToday(endRange)
      
        // return;
      }
    }
  setStartRange(e.target.value);
  };
  const handleEndRange = (e) => {
    setEndRange(e.target.value);
    setDateToday(e.target.value);
    };

    const handleClear=()=>{
      getCall();
      setChangeLoggerData([]);
      setBoolean(false);
      setSearchBool(false);
      setSearchText(""); 
      setCurrentPagePagination(1);
    }

    const handleApply=()=>{
      setCurrentPagePagination(1)
      setSearchBool(true);
      Setloading_flag(true);
      setSearchText("");
      if(startRange!=="" && endRange!==""){
        axios
        .post(base_url + "changeLoggerv2/fetch_details_in_date_range",{
            "from_date":startRange,
            "to_date":endRange
        })
        .then((res) => {
          if(res.data.data.length===0){
            setBoolean(true);
            // setChangeLoggerData(res.data.data);
            setPmsChangeData(res.data.data);
            setTimeout(()=>{
              Setloading_flag(false);
            },200);
          }
          else{
            setBoolean(false)
            setChangeLoggerData(res.data.data);
            setPmsChangeData(res.data.data);
            setTimeout(()=>{
              Setloading_flag(false);
            },200);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      }
    }
    useEffect(() => {
      const handleResize = () => {
        const screenWidth = window.innerWidth;
  
        if (screenWidth >= 1500) {
          setPostsPerPage(8); // Extra large screen, set to 10 items per page
        } else {
          setPostsPerPage(4); // Large screen, set to 5 items per page
        }
      };
  
      // Initial setup
      handleResize();
  
      // Event listener for window resize
      window.addEventListener('resize', handleResize);
  
      // Cleanup event listener on component unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  
    const[paginateBool,setPaginateBool]=useState(false)
    useEffect(()=>{
      if(searchText.length>0 && changeLoggerData.length===0){
        setPaginateBool(true);
      }
      else if(searchText.length===0 && changeLoggerData.length>0){
        setPaginateBool(false);
      }
},[changeLoggerData,searchText])

    


    const CardsPerPage = 10;
    const indexOfLastCard = currentPagePagination * CardsPerPage;
    const indexOfFirstCard = indexOfLastCard - CardsPerPage;
    const currentCards = changeLoggerData.length>0 ? changeLoggerData.slice(indexOfFirstCard, indexOfLastCard):pmsChangeData.slice(indexOfFirstCard, indexOfLastCard);
   
    const pagination = (pageNumber) => setCurrentPagePagination(pageNumber);
   
    const jumpToFirstPage = () => setCurrentPagePagination(1);
   
    const jumpToLastPage = () => setCurrentPagePagination(changeLoggerData.length>0 ? Math.ceil(changeLoggerData.length / CardsPerPage): Math.ceil(pmsChangeData.length / CardsPerPage));
   

  return (
    <div>
    <NavigationBar studyDropdwn={true} title={"Audit Trail"}  rolecode={rolecode}/>
    <div className="main_body">
    {currentPage === 1 && (
      <Container fluid  className="pt-2 pb-3 py-lg-2 py-md-2 py-xxl-4 mblbgclr mb-5">
         <Stack 
                 direction="horizontal"
                 className="p-0 pb-md-2 pb-lg-2 pb-xxl-2 add_subject_stack  d-flex justify-content-between">  
                
                <div className=" d-flex  justify-content-md-start gap-1 pilistfiltrs">
                <div className="col" style={{ display: "flex", alignItems: "center",width:"350px" }}>
  <label htmlFor="lastName" style={{ marginRight: "5px" }}>
    Start Date
  </label>
                    <input
                      value={startRange}
                      className=""
                      id="lastName"
                      max={date_today}
                      type="date"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "225px" ,cursor: "not-allowed"}}
                      onChange={handleStartRange}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    </div>
                    <div className="col" style={{ display: "flex", alignItems: "center" }}>
                    <label htmlFor="lastName" style={{ marginRight: "8px" }}>
                      End Date
                    </label>
                    <input
                      value={endRange}
                      className=""
                      id="lastName"
                      type="date"
                      disabled={!startRange}
                      min={startRange}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "225px", cursor: "not-allowed" }}
                      onChange={handleEndRange}
                      onKeyDown={(e) => e.preventDefault()}
                      max={today}
                    />
                  </div>
                  <div className="clr_btn_mdqr mt-1">
                    <button className="orange_btn" disabled={!startRange || !endRange} onClick={handleApply} >
                      Apply
                    </button>
                  </div>
                  <div className="clr_btn_mdqr mt-1">
                    <button className="orange_btn" disabled={!startRange || !endRange} onClick={handleClear} >
                      Clear
                    </button>
                  </div>
                 
                  </div>

                <div>
                      <Row className='searchbar'>
                            <Col className='searchFiled gap-1 d-flex flex-row pe-0'>
                                <label htmlFor="" />
                                <input type="search" value={searchText} onChange={handleSearchData} placeholder='Persona or Created by'   title='Search with Persona or Created by'/>
                                <div >
                                        <button
                                            className="btn btn-success "
                                            onClick={exportToExcel}
                                            style={{height:"42px",width:"160px",padding:"2px"}}
                                        >
                                            Download XLS
                                            <img src="./images/icons/download.svg" alt="#" style={{marginLeft:"5px"}}/>
                                        </button>
                                        
                                    </div>
                            </Col>
                        </Row>      
                    </div>
                   
                     </Stack> 
     
            
          <Container fluid className="pitable_container mt-2 p-0 mb-2 ">
                
            <div>
              {loading_flag ? (
                <div className=''>
                  <img
                    className="atrium_loader"
                    src="/images/circle-effect-loading.gif"
                    alt="Loader"

                  />
                </div>

              ) : (
                <div className="table-scroll-container " style={{ border: "1px solid #E1E5E7 " }}>
                 
                   {pmsChangeData?.length > 0 ? 
                    <Table bordered size="sm" className="pitable mb-0">
                      <thead className='sticky_table_header'>
                        <tr>
                          <th> S.No</th>
                          <th style={{ minWidth: "145px" }}>
                          Persona
                            
                          </th>
                          <th >
                            Entity
                            
                          </th>
                          <th>
                            Action
                            
                          </th>
                          <th >
                            Change From
                            
                          </th>
                          <th >
                            Change To
                            
                          </th>
                          <th>
                          Created By
                            
                          </th>
                         

                          <th>
                                                        Created On
                                                        </th>
                                                        {/* <th>
                          Updated On
                          
                          </th> */}
                     
                        </tr>
                      </thead>

                      <tbody className="tableBodyScroll">
                      {changeLoggerData.length > 0  ? (
                        currentCards?.map((i, index) => {
                        const originalIndex = changeLoggerData.indexOf(i);
                        return ( 
                          <tr className="text_left_table">
                            <td className='text_right_sno'> {originalIndex+1} </td>
                            <td >{i?.actors ? i?.actors :"-"}</td>
                            <td style={{maxWidth: '200px'}}>{i?.entity ? i?.entity :"-"}</td>
                            {/* <td>{i.site_name}</td> */}
                            <td>{i?.action ? i?.action :"-"}</td>
                            <td >
                          <div style={{maxHeight: "70px", overflowY: "auto" }}>
                              {i?.change_from ? typeof i.change_from === 'object' && (
                                i?.change_from && (
                                  Array.isArray(i.change_from)
                                    ? (
                                      <div>
                                        {i.change_from.map((value, index) => (
                                          <div key={index}>
                                            {value}
                                          </div>
                                        ))}
                                      </div>
                                    )
                                    : (
                                      Object.keys(i.change_from).map((key) => (
                                        !(
                                          i?.change_from[key] === null ||
                                          i?.change_from[key] === undefined ||
                                          i?.change_from[key] === ''
                                        ) && (
                                          <div key={key} className={key === 'email' ? 'lowercase-key' : ''}>
                                            {key === 'aadhar_card_number'
                                              ? `${key} : ******** ${i?.change_from[key].slice(-4)}`
                                              : key === 'email'
                                              ? `${key} : ${i?.change_from[key]} `
                                              : `${key} : ${i?.change_from[key]}`
                                            }
                                          </div>
                                        )
                                      ))
                                    )
                                )
                              ) :"-"}

                            </div>

                          </td>
                          <td style={{height:"70px"}}>
                            <div style={{ maxHeight: "70px", overflowY: "auto" }}>
                            {i.change_to ? typeof i.change_to === 'object' && (
                              i?.change_to && (
                                Array.isArray(i.change_to)
                                  ? (
                                    <div>
                                      {i.change_to.map((value, index) => (
                                        <div key={index}>
                                          {value}
                                        </div>
                                      ))}
                                    </div>
                                  )
                                  : (
                                    Object.keys(i.change_to).map((key) => (
                                      !(
                                        i?.change_to[key] === null ||
                                        i?.change_to[key] === undefined ||
                                        i?.change_to[key] === ''
                                      ) && (
                                        <div key={key} className={key === 'email' ? 'lowercase-key' : ''}>
                                          {key === 'aadhar_card_number'
                                            ? `${key} : ******** ${i?.change_to[key].slice(-4)}`
                                            : key === 'email'
                                            ? `${key} : ${i?.change_to[key]} `
                                            : `${key} : ${i?.change_to[key]}`
                                          }
                                        </div>
                                      )
                                    ))
                                  )
                              )
                            ):"-"}

                          </div>


                          </td>
                            <td>{i?.UserAccess?.name ? i?.UserAccess?.name:"-"}</td>
                            <td className='text-center'>{getDate(i?.createdAt)}</td>
                            {/* <td className='text-center'>{getDate(i?.updatedAt)}</td> */}
                           
                          </tr>
                        ); 
                         })): (pmsChangeData.length > 0 && searchText.length > 0)||(pmsChangeData.length>0 && changeLoggerData.length===0 && bool) ? (
                            <tr className="text-center">
                              <td colSpan="8">No records found</td>
                            </tr>
                          ):
                           (
                            currentCards?.map((i, index) => {
                              const originalIndex = pmsChangeData.indexOf(i);
                               return ( 
                                <tr className="text_left_table">
                                  <td className='text_right_sno'> {originalIndex+1} </td>
                                  <td>{i?.actors ? i?.actors : "-"}</td>
                                  <td style={{maxWidth: '200px'}}>{i?.entity ? i?.entity : "-"}</td>
                                  {/* <td>{i.site_name}</td> */}
                                  <td>{i?.action ? i?.action : "-"}</td>
                                  <td >
                                <div style={{ maxHeight: "70px", overflowY: "auto" }}>
                                    {typeof i.change_from === 'object' && (
                                        i?.change_from && (
                                          Array.isArray(i.change_from)
                                            ? (
                                              <div>
                                                {i.change_from ? i.change_from.map((value, index) => (
                                                  <div key={index}>
                                                    {value}
                                                  </div>
                                                )):"-"}
                                              </div>
                                            )
                                            : i.change_from ? (
                                              Object.keys(i.change_from).map((key) => (
                                                !(
                                                  i?.change_from[key] === null ||
                                                  i?.change_from[key] === undefined ||
                                                  i?.change_from[key] === ''
                                                ) && (
                                                  <div key={key} className={key === 'email' ? 'lowercase-key' : ''}>
                                                    {key === 'aadhar_card_number'
                                                      ? `${key} : ******** ${i?.change_from[key].slice(-4)}`
                                                      : key === 'email'
                                                      ? `${key} : ${i?.change_from[key]} `
                                                      : `${key} : ${i?.change_from[key]}`
                                                    }
                                                  </div>
                                                )
                                              ))
                                            ):"-"
                                        )
                                      )}

                                  </div>

                                </td>
                                <td style={{height:"70px"}}>
                                 <div style={{ maxHeight: "70px", overflowY: "auto" }}>
                                 {i.change_to ? typeof i.change_to === 'object' && (
                                      i?.change_to && (
                                        Array.isArray(i.change_to)
                                          ? (
                                            <div>
                                              {i.change_to.map((value, index) => (
                                                <div key={index}>
                                                  {value}
                                                </div>
                                              ))}
                                            </div>
                                          )
                                          : (
                                            Object.keys(i.change_to).map((key) => (
                                              !(
                                                i?.change_to[key] === null ||
                                                i?.change_to[key] === undefined ||
                                                i?.change_to[key] === ''
                                              ) && (
                                                <div key={key} className={key === 'email' ? 'lowercase-key' : ''}>
                                                  {key === 'aadhar_card_number'
                                                    ? `${key} : ******** ${i?.change_to[key].slice(-4)}`
                                                    : key === 'email'
                                                    ? `${key} : ${i?.change_to[key]} `
                                                    : `${key} : ${i?.change_to[key]}`
                                                  }
                                                </div>
                                              )
                                            ))
                                          )
                                      )
                                    ) :"-"}

                                                                    
                                  </div>
                                  


                                </td>
                                  <td>{i?.UserAccess?.name}</td>
                                  <td className='text-center'>{getDate(i?.createdAt)}</td>
                                  {/* <td className='text-center'>{getDate(i?.updatedAt)}</td> */}
                                 
                                </tr>
                              ); 
                               }))} 
                      </tbody>
                    </Table>
                    :
                    <div className="bg-white border py-4 text-center">No records found with search criteria</div>

                  } 
                </div>
                
              )}
               {/* <div className="footer-pagination pb-3">
                 {changeLoggerData.length>0 ? changeLoggerData?.length>4 : pmsChangeData?.length>4 && <Pagination
                    jumpToFirstPage={jumpToFirstPage}
                    jumpToLastPage={jumpToLastPage}
                    currentPagePagination={currentPagePagination}
                    pagination={pagination}
                    CardsPerPage={CardsPerPage}
                    filteredStudies={changeLoggerData.length>0 ?changeLoggerData:pmsChangeData}
                  />} */}
                  <div className="footer-pagination pb-3">
    {(changeLoggerData.length > 0 ? changeLoggerData : searchText.length===0 ? pmsChangeData : changeLoggerData).length > 4 && (
        <Pagination
            pmsChangeData={searchText.length===0 ? pmsChangeData : changeLoggerData}
            jumpToFirstPage={jumpToFirstPage}
            jumpToLastPage={jumpToLastPage}
            currentPagePagination={currentPagePagination}
            pagination={pagination}
            CardsPerPage={CardsPerPage}
            filteredStudies={changeLoggerData.length > 0 ? changeLoggerData : pmsChangeData}
        />
    )}



            {/* <Paginate
               onPageChange={(number) => paginate(number)}
                previousPage={previousPage}
                nextPage={nextPage}
                pageCount={changeLoggerData.length>0 ? Math.ceil(changeLoggerData.length / postsPerPage):paginateBool? 0 :Math.ceil(pmsChangeData.length / postsPerPage)}
                postsPerPage={postsPerPage}
                totalPosts={changeLoggerData.length>0 ? changeLoggerData.length: paginateBool? 0 : pmsChangeData.length}
                currentPage={currentPage1}
                /> */}
            </div>
            </div>
          </Container>
         
      </Container>

     )} 

  </div>

  </div>
  )
}

export default PMSAdminChangeLogger2
